import { Form, InputNumber } from 'antd';
import { useContext } from 'react';

import { AddOrderDeliveryContext } from './AddOrderDeliveryContext';
import { clampProductUnit } from './quantity';

/**
 * Барааны "Тоо ширхэг" талбар — агуулах ба салбарын хүснэгт хоёулаа хэрэглэнэ.
 *
 * `InputNumber`-ийн `min`/`max`-ыг ЗОРИУДААР хэрэглээгүй: тэдгээр нь фокус
 * алдахад утгыг ЧИМЭЭГҮЙ хумидаг тул хэрэглэгч 999 бичээд 198 болчихсоныг
 * анзаарахгүй үлдэж, өөрийн бичсэн тоогоор захиалга үүссэн гэж андуурдаг байв.
 * Оронд нь хумилтыг өөрсдөө хийж, юу өөрчлөгдсөнийг талбар дээр нь шар
 * мэдэгдлээр харуулна ({@link clampProductUnit}).
 */
const ProductUnitField = ({ form, name, availableStock, defaultValue, onChangeUnit }) => {
  const addContext = useContext(AddOrderDeliveryContext);

  const handleBlur = () => {
    const { value, notice } = clampProductUnit(form.getFieldValue(name), availableStock);
    if (!notice) return;

    form.setFields([{ name, value, warnings: [notice] }]);
    onChangeUnit(value);
    // setFields нь onValuesChange-ыг дуудахгүй тул draft-ыг өөрсдөө шинэчилнэ
    addContext?.setFormDataStep1?.((prev) => ({ ...prev, formValues: form.getFieldsValue() }));
  };

  return (
    <Form.Item
      name={name}
      style={{ marginBottom: 0 }}
      rules={[
        { required: true, message: 'Тоо ширхэг оруулна уу!' },
        { pattern: new RegExp(/^[0-9]+$/), message: 'Бүхэл тоо оруулна уу!' },
      ]}
    >
      <InputNumber
        placeholder="0"
        addonAfter="ш"
        style={{ width: '100%' }}
        defaultValue={defaultValue}
        onChange={onChangeUnit}
        onBlur={handleBlur}
      />
    </Form.Item>
  );
};

export default ProductUnitField;
